import { useState } from "react";
import FieldInput from "./FieldInput";
import images from "../../../images";
import translate from "../../../Utils/translate";

const FieldPassword = (props) => {
  const [type, setType] = useState("password");

  const handleShowPassword = (event) => {
    event.preventDefault();
    type === "password" ? setType("text") : setType("password");
  };

  const icon = type === "password" ? images.icons.eyeOpen : images.icons.eyeClose;

  return (
    <FieldInput
      icon={icon}
      onClick={handleShowPassword}
      placeholder={translate("forms.password.placeholder")}
      type={type}
      {...props}
    />
  );
};

export default FieldPassword;
